// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hw-0";
export var actionModalContentContainer = "_hw-1";
export var createTagButton = "_hw-2";
export var footerContainer = "_hw-7";
export var fullWidthDivider = "_hw-3";
export var hasCreateTagButton = "_hw-4";
export var noCreateTagButton = "_hw-5";
export var tagsContainer = "_hw-6";
export var tagsModalContentContainer = "_hw-8";